import React, { useEffect } from 'react';

const CloseIcon: React.FC = () => (
  <svg aria-hidden='true' viewBox='0 0 24 24'>
    <path d='M18.3 5.7L12 12l6.3 6.3-1.4 1.4L10.6 13.4 4.3 19.7l-1.4-1.4L9.2 12 2.9 5.7l1.4-1.4 6.3 6.3 6.3-6.3 1.4 1.4z' />
  </svg>
);

export interface FooterModalProps {
  open: boolean;
  title: string;
  labelledBy: string;
  closeRef: React.RefObject<HTMLButtonElement>;
  onClose: () => void;
  children: React.ReactNode;
}

export const FooterModal: React.FC<FooterModalProps> = ({
  open,
  title,
  labelledBy,
  closeRef,
  onClose,
  children,
}) => {
  useEffect(() => {
    if (!open) return undefined;
    function handleKey(event: KeyboardEvent): void {
      if (event.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', handleKey);
    closeRef.current?.focus();
    return () => document.removeEventListener('keydown', handleKey);
  }, [open, onClose, closeRef]);

  return (
    <div
      aria-hidden={!open}
      aria-labelledby={labelledBy}
      aria-modal='true'
      className={`footer-modal${open ? ' open' : ''}`}
      onClick={(event) => {
        if (open && event.target === event.currentTarget) onClose();
      }}
      role='dialog'
    >
      <section className='footer-modal-card' role='document'>
        <div className='footer-modal-header'>
          <h3 id={labelledBy}>{title}</h3>
          <button
            aria-label='Cerrar'
            className='footer-modal-close'
            onClick={onClose}
            ref={closeRef}
            type='button'
          >
            <CloseIcon />
          </button>
        </div>
        <div className='footer-modal-body'>{children}</div>
      </section>
    </div>
  );
};
